import React, { useMemo } from 'react';
import { Box, Heading } from "@chakra-ui/react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const AgentServiceTimePerServiceLineGraph = React.memo(({
  chart,
  title,
  height,
  lineName = "Average Session Time",
}) => {
  const chartData = useMemo(() => chart, [chart]);

  return (
    <>
      <Box width="100%">
        <ResponsiveContainer width="100%" height={height ? parseInt(height) : 300} debounce={300}>
          <LineChart
            data={chartData}
            margin={{
              top: 0,
              right: 10,
              left: -10,
              bottom: 15,
            }}
          >
            <CartesianGrid stroke="#EBEBEB" vertical={false} />
            <XAxis
              dataKey="hour"
              name="Hour"
              axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }}
            />
            <YAxis axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }} />
            <Tooltip />
            <Legend width="100%" />
            <Line
              type="monotone"
              strokeWidth={1.6}
              dataKey="hourlyAverage"
              name={lineName}
              stroke={"var(--blue)"}
              dot={{ fill: "var(--blue)", r: 2 }}
              activeDot={{ r: 4 }}
              isAnimationActive={false}
            />
          </LineChart>
        </ResponsiveContainer>
        {title && (
          <Heading
            size="sm"
            fontWeight={400}
            fontSize="14px"
            color="#535353"
            mb="20px"
            textAlign="center"
          >
            {title}
          </Heading>
        )}
      </Box>
    </>
  );
});

export default AgentServiceTimePerServiceLineGraph;
